import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import Splash from 'splash';
import errorHandler from 'errorHandler';
import { getInitParams } from 'utils';
import initializeApp from 'app';
import { fetchPropertyResource } from './resources';

const { REACT_APP_ENV } = process.env;
const { propertyId } = getInitParams();

const renderSplash = (type) => {
  ReactDOM.render(
    // The flyer thumbnail is never shown before the property is fetched: the property may ask to hide it
    // (`hide_thumbnail_on_flyer_loading`), so it is shown only by the splash rendered in `initializeApp`.
    // eslint-disable-next-line
    <Splash type={type} hideThumbnail />,
    document.getElementById('root'),
  );
};

(async () => {
  if (propertyId) {
    renderSplash();

    try {
      const propertyResource = await fetchPropertyResource();

      const { property } = propertyResource;
      if (property.is_active === false) throw new Error('Property inactive');

      initializeApp(propertyResource);
    } catch (e) {
      if (REACT_APP_ENV === 'dev') errorHandler(e); // eslint-disable-line
      renderSplash('error');
    }
  } else {
    if (REACT_APP_ENV === 'dev') errorHandler('propertyId not found'); // eslint-disable-line
    renderSplash('error');
  }
})();
